/**
 * BT-054 — Admin users / official email API.
 */
import { backendFetch } from "@/api/karateBackendApi.js";

export async function apiFetchUsers() {
  return backendFetch("/api/v1/users");
}

export async function apiFetchUser(userId) {
  return backendFetch(`/api/v1/users/${userId}`);
}

export async function apiReplaceUserEmail(userId, officialEmail, locale = "fr") {
  return backendFetch(`/api/v1/users/${userId}/email`, {
    method: "PATCH",
    body: JSON.stringify({ officialEmail, locale }),
  });
}

export async function apiUpdateUserEmailStatus(userId, emailStatus, locale = "fr") {
  return backendFetch(`/api/v1/users/${userId}/email-status`, {
    method: "PATCH",
    body: JSON.stringify({ emailStatus, locale }),
  });
}

export async function apiForceUserPasswordChange(userId) {
  return backendFetch(`/api/v1/users/${userId}/force-password-change`, { method: "PATCH", body: "{}" });
}

export async function apiResetUserTemporaryPassword(userId, locale = "fr") {
  return backendFetch(`/api/v1/users/${userId}/reset-temporary-password`, {
    method: "POST",
    body: JSON.stringify({ locale }),
  });
}
